export const groupMatchesByDate = (matches) => {
    return PULSE.app.common.arrayHelper.groupBy(matches, (match) => {
        // Group cancelled/postponed matches under their status keys
        if (PULSE.app.common.match.cancelledOrPostponed(match.status)) {
            return match.status;
        }

        return moment(match.utcStartTime).format('YYYYMMDD');
    });
};
